module.exports = __webpack_public_path__ + "img/titleImg.06d3ad02.png";